export const getIsSubmitting = state => state.deleteUser_system.get('isSubmitting')
